import { Button, Popover, PopoverTrigger, PopoverContent } from '@you/ui'
import { useSidebar } from '@/components/ui/sidebar'
import { Icon } from '@/components/Icon'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { useWorkspaces } from '@/api'
import { useWorkspaceStore } from '@/stores/workspaceStore'
import { useState } from 'react'
import { WorkspaceType } from '@/api/types/workspace.types'

// 金色认证 Tag：代表渠道认证的组织空间
const OrgCertTag = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="flex-none">
    <circle cx="8" cy="8" r="7.5" fill="#FFF7E0" stroke="#F5A623" />
    <path d="M4.5 8.5L7 11L11.5 5.5" stroke="#F5A623" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export function SpaceMain() {
  const { data } = useWorkspaces()
  const { open } = useSidebar()
  const { currentWorkspace, setCurrentWorkspace } = useWorkspaceStore()
  const [popoverOpen, setPopoverOpen] = useState(false)

  const isCurrentOrg = currentWorkspace?.type === WorkspaceType.Organization

  return (
    <Popover open={popoverOpen} onOpenChange={setPopoverOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          className="w-full text-lg px-1 mb-2 text-left justify-start text-[#333333] overflow-hidden"
        >
          <Avatar className="h-5 w-5 rounded-full">
            <AvatarImage src={currentWorkspace?.icon} alt={currentWorkspace?.name} />
            <AvatarFallback className="rounded-full text-[12px]">
              {currentWorkspace?.name.slice(0, 1)}
            </AvatarFallback>
          </Avatar>
          {open && (
            <div className="mx-2 flex items-center gap-1.5 min-w-0">
              <p className="text-xl whitespace-nowrap overflow-hidden text-ellipsis">
                {currentWorkspace?.name}
              </p>
              {isCurrentOrg && <OrgCertTag />}
            </div>
          )}
          <Icon name="change" className="flex-none" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" side="bottom" className="w-[248px] p-0">
        <ul className="text-lg text-[#333333] text-left border-b-2 border-[#8752FF1A] py-1 max-h-[300px] overflow-y-auto [&>li]:leading-[48px] [&>li:hover]:bg-[#8752FF1A] [&>li]:cursor-pointer [&>li]:px-4">
          {data?.workspaces?.map((space) => (
            <li
              key={space.id}
              className="flex items-center justify-between"
              onClick={() => {
                setCurrentWorkspace(space)
                setPopoverOpen(false)
              }}
            >
              <div className="flex items-center gap-2 min-w-0">
                <Avatar className="h-5 w-5 rounded-full flex-none">
                  <AvatarImage src={space.icon} alt={space.name} />
                  <AvatarFallback className="rounded-full text-[12px]">
                    {space.name.slice(0, 1)}
                  </AvatarFallback>
                </Avatar>
                <span className="truncate">{space.name}</span>
              </div>
              {space.type === WorkspaceType.Organization && <OrgCertTag />}
            </li>
          ))}
        </ul>
        {/* 新增工作空间入口已关闭：空间创建权限收归渠道后台 */}
      </PopoverContent>
    </Popover>
  )
}
